
const domainName = window.location.hostname
// const newStageUrl = 'https://stagingapi.llpsales.com';
const newStageUrl = 'https://stgapigateway.llpsales.com/stggateway';
// const newLiveUrl = 'https://uatapi.llpsales.com';
const newLiveUrl = 'https://uatapigateway.llpsales.com/uatgateway';
const oldUrl = 'http://3.228.238.128';
export const newScriptUrl = 'https://python-services.llpsales.com/api';
console.log('Domain Name:', domainName);

const oldApi = {

    // ==========7000==========

    baseUrl1: `${oldUrl}:7001`,
    baseUrl2: `${oldUrl}:7002`,
    baseUrl3: `${oldUrl}:7003`,
    baseUrl4: `${oldUrl}:7004`,
    baseUrl5: `${oldUrl}:7005`,
    baseUrl6: `${oldUrl}:7006`,
    baseUrl7: `${oldUrl}:7007`,
    baseUrl8: `${oldUrl}:7008`,
    baseUrl15: `${oldUrl}:70015`,
    baseUrl16: `${oldUrl}:70016`,

    // ==========9000==========

    baseUrl00: `${oldUrl}:9000`,
    baseUrl06: `${oldUrl}:9006`,
    baseUrl51: `${oldUrl}:9051`,
    baseUrl10: `${oldUrl}:9010`,

    // ==========6000==========

    baseUrl9: `${oldUrl}:6009`,

}


const stageApi = {

    // staging/local/UIPL server
    // ==========7000==========

    //http://3.228.238.128:7001 
    baseUrl1: `${newStageUrl}`,
    // http://3.228.238.128:7002
    baseUrl2: `${newStageUrl}`,
    // http://3.228.238.128:7003
    baseUrl3: `${newStageUrl}`,
    // http://3.228.238.128:7004
    baseUrl4: `${newStageUrl}`,
    // http://3.228.238.128:7005
    baseUrl5: `${newStageUrl}`,
    // http://3.228.238.128:7006
    baseUrl6: `${newStageUrl}`,
    // http://3.228.238.128:7007
    baseUrl7: `${newStageUrl}`,
    // http://3.228.238.128:7008
    baseUrl8: `${newStageUrl}`,
    // http://3.228.238.128:70015
    baseUrl15: `${newStageUrl}`,
    // http://3.228.238.128:70016
    baseUrl16: `${newStageUrl}`,

    // ==========9000==========

    //http://3.228.238.128:9000
    baseUrl00: `${newStageUrl}`,
    //http://3.228.238.128:9006
    baseUrl06: `${newStageUrl}`,
    // http://3.228.238.128:9051
    baseUrl51: `${newStageUrl}`,
    // http://3.228.238.128:9010
    baseUrl10: `${newStageUrl}`,

    // ==========6000==========

    // http://3.228.238.128:6009
    baseUrl9: `${newStageUrl}`,

}

const liveApi = {

    // Live
    // ==========7000==========

    //http://3.228.238.128:7001    
    baseUrl1: `${newLiveUrl}`,
    // http://3.228.238.128:7002
    baseUrl2: `${newLiveUrl}`,
    // http://3.228.238.128:7003
    baseUrl3: `${newLiveUrl}`,
    // http://3.228.238.128:7004
    baseUrl4: `${newLiveUrl}`,
    // http://3.228.238.128:7005
    baseUrl5: `${newLiveUrl}`,
    // http://3.228.238.128:7006
    baseUrl6: `${newLiveUrl}`,
    // http://3.228.238.128:7007
    baseUrl7: `${newLiveUrl}`,
    // http://3.228.238.128:7008
    baseUrl8: `${newLiveUrl}`,
    // http://3.228.238.128:70015
    baseUrl15: `${newLiveUrl}`,
    // http://3.228.238.128:70016
    baseUrl16: `${newLiveUrl}`,

    // ==========9000==========

    //http://3.228.238.128:9000
    baseUrl00: `${newLiveUrl}`,
    //http://3.228.238.128:9006
    baseUrl06: `${newLiveUrl}`,
    // http://3.228.238.128:9051
    baseUrl51: `${newLiveUrl}`,
    // http://3.228.238.128:9010
    baseUrl10: `${newLiveUrl}`,

    // ==========6000==========

    // http://3.228.238.128:6009
    baseUrl9: `${newLiveUrl}`,

}

const api = domainName === 'localhost' || domainName === 'staging.llpsales.com' ? stageApi : liveApi;

export default api;